import React, { memo } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import history from 'utils/history';
import PrivateRoutes from './PrivateRoutes';
import Auth from './Auth';

function Routes(props) {
	return (
		<BrowserRouter>
			<Switch>
				<Route path="/app">
					<PrivateRoutes themeswitchfunction={props.themeswitchfunction}/>
				</Route>

				<Route path="">
					<Auth />
				</Route>
			</Switch>
		</BrowserRouter>
	)
}

export default memo(Routes);
